import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ghippo-message-drawer-title" }
const _hoisted_2 = { class: "ghippo-message-created_at" }

import {
  ref, reactive, computed,
} from 'vue';
import { simpleErrorNoty } from '@/utils/noty';
import {
  Message, type MessageInfo,
} from '@daocloud-proto/ghippo/v1alpha1/message.pb';
import { useDateFormat } from '@dao-style/extend';
import { useI18n } from 'vue-i18n';
import { useGlobalStore } from '@/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageBox',
  setup(__props, { expose }) {

const { t } = useI18n();

const store = useGlobalStore();

const messagesInfo = reactive({
  unread: 0,
  messages: [] as MessageInfo[],
});

const fetchMessagesList = async () => {
  try {
    const { items = [] } = await Message.ListMessages({
      pageSize: 10,
      page: 1,
      search: '',
      unreadCount: false,
    });

    messagesInfo.messages = items;
  } catch (e) {
    simpleErrorNoty(e, {
      name: t('components.MessageBox.list'),
    });
  }
};

const isEmpty = computed(() => !messagesInfo.messages.length);

const isShow = ref(false);

const closeDrawer = () => {
  isShow.value = false;
};

const openDrawer = () => {
  isShow.value = true;
};

expose({
  openDrawer,
  fetchMessagesList,
});

fetchMessagesList();


return (_ctx: any,_cache: any) => {
  const _component_dao_history_link = _resolveComponent("dao-history-link")!
  const _component_dao_action_icon = _resolveComponent("dao-action-icon")!
  const _component_dao_empty = _resolveComponent("dao-empty")!
  const _component_dao_drawer = _resolveComponent("dao-drawer")!

  return (_openBlock(), _createBlock(_component_dao_drawer, {
    modelValue: isShow.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShow).value = $event)),
    size: "sm",
    "hide-footer": ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('components.MessageBox.messageBox')), 1),
      _createVNode(_component_dao_history_link, {
        type: "action",
        class: "ghippo-message-header-link",
        href: _unref(store).getProductLink('ghippo','/messages/all/list'),
        onPushState: closeDrawer
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('components.MessageBox.more')), 1)
        ]),
        _: 1
      }, 8, ["href"]),
      _createVNode(_component_dao_action_icon, {
        name: "icon-close",
        onClick: closeDrawer
      })
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messagesInfo.messages, (value) => {
        return (_openBlock(), _createBlock(_component_dao_history_link, {
          key: value.id,
          type: "action",
          href: _unref(store).getProductLink('ghippo',`/messages/${value.read}/${value.id}/detail`),
          class: "ghippo-message-item-link",
          onPushState: closeDrawer
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", {
              class: _normalizeClass(["ghippo-message-subject", {'ghippo-message-unread': value.read !== 'read'}])
            }, _toDisplayString(value.subject), 3),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(useDateFormat)(value.createdAt)), 1)
          ]),
          _: 2
        }, 1032, ["href"]))
      }), 128)),
      (_unref(isEmpty))
        ? (_openBlock(), _createBlock(_component_dao_empty, {
            key: 0,
            type: "full",
            title: _ctx.$t('components.MessageBox.noMessage')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})